
export const ACTIONS_WB = {
  ADD_PRODUCTS: 'ADD_WB_PRODUCTS',
  CHANGE_PRODUCT: 'CHANGE_WB_PRODUCT',
  CHANGE_MARKET: 'CHANGE_WB_MARKET',
};

export const addWbProducts = data => ({
  type: ACTIONS_WB.ADD_PRODUCTS,
  data,
});

export const actionChangeWbProduct = (product = {}) => ({
  type: ACTIONS_WB.CHANGE_PRODUCT,
  product,
});

export const changeWbMarket = market => ({
  type: ACTIONS_WB.CHANGE_MARKET,
  market,
});
